<template>
    <div :class="`table-summary-rel ${fullWidth ? 'fullWidth' : ''} ${colClass} `">
      <div :class="`inner-table-summary ${fullWidth ? 'fullWidth' : ''}`">
        <div class="d-flex flex-sm-row flex-column" style="gap: 24px;">
          <div class="content-column">
            <div :class="`table-summary-title ${fullWidth ? 'fullWidth' : ''} ${subtitle ? '' : ''}`">
              <h6 class="title-rel m-0 p-0">{{ title }}</h6>
              <p v-if="subtitle" :class="'subtitle-rel m-0 p-0'">
                {{ subtitle }}
                <br><b class="subtitle-warning">{{ subtitleWarning }}</b>
              </p>
            </div>
            <slot></slot>
          </div>
          
          <div v-if="total || subtotal" class="total-column">
            <div v-if="total" class="total-value">{{ total }}</div>
            <div v-if="subtotal" class="subtotal-value">{{ subtotal }}</div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  
  <script>
  export default {
    name: "TableSummary",
    props: {
      subtitle: String,
      subtitleWarning: String,
      title: String,
      fullWidth: Boolean,
      cols: {
        type: Number,
        default: 12,
        validator: value => value >= 1 && value <= 12
      },
      total: String,
      subtotal: String
    },
    computed: {
      colClass() {
        return `colx-${this.cols}`;
      }
    }
  }
  </script>
  <style scoped>
  .subtitle-warning{
    color: #6B7280;
  }
  
  .mb-24 {
    margin-bottom: 24px;
  }
  
  .inner-table-summary {
    padding: 24px;
  
    &.fullWidth {
      padding: 0;
    }
  }
  
  .table-summary-rel {
    border: 0px;
    box-sizing: border-box;
    border-radius: 8px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  
    &.fullWidth {
      padding: 0;
    }
  
    .table-summary-title {
      gap: 4px;
      display: flex;
      flex-direction: column;
  
      &.fullWidth {
        padding: 16px 24px;
      }
    }
  }
  
  .subtitle-rel {
    font-family: Inter;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #6B7280;
    max-width: 50%;
    
    /* Novos breakpoints */
    @media (max-width: 1360px) {
        max-width: 80%;
    }
    
    @media (max-width: 800px) {
        max-width: 100%;
    }
  }
  
  .title-rel {
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
    color: #111827;
  }
  
  .rowx {
    display: flex;
    justify-content: space-between;
    gap: 24px;
    width: 100%;
  }
  
  .content-column {
    flex-grow: 1;
  }
  
  .total-column {
    text-align: right;
    min-width: 200px;
    margin-left: auto;
    padding-left: 24px;
  }
  
  .total-value {
    font-family: Inter;
    font-size: 20px;
    font-weight: 600;
    color: #111827;
    line-height: 28px;
  }
  
  .subtotal-value {
    font-family: Inter;
    font-size: 14px;
    color: #6B7280;
    line-height: 20px;
    margin-top: 4px;
  }
  
  [class*="colx-"] {
    position: relative;
    flex-grow: 1;
    flex-basis: calc((100% / 12) - 24px);
    /* Ajusta a largura para incluir o gap */
    max-width: calc((100% / 12) - 24px);
    /* Ajusta a largura para incluir o gap */
    box-sizing: border-box;
    /* Inclui padding na largura total */
  }
  
  .colx-1 {
    flex: 0 0 calc((100% / 12 * 1) - 24px);
    max-width: calc((100% / 12 * 1) - 24px);
  }
  
  .colx-2 {
    flex: 0 0 calc((100% / 12 * 2) - 24px);
    max-width: calc((100% / 12 * 2) - 24px);
  }
  
  .colx-3 {
    flex: 0 0 calc((100% / 12 * 3) - 24px);
    max-width: calc((100% / 12 * 3) - 24px);
  }
  
  .colx-4 {
    flex: 0 0 calc((100% / 12 * 4) - 16px);
    max-width: calc((100% / 12 * 4) - 16px);
  }
  
  .colx-5 {
    flex: 0 0 calc((100% / 12 * 5) - 24px);
    max-width: calc((100% / 12 * 5) - 24px);
  }
  
  .colx-6 {
    flex: 0 0 calc((100% / 12 * 6) - 12px);
    max-width: calc((100% / 12 * 6) - 12px);
  }
  
  .colx-7 {
    flex: 0 0 calc((100% / 12 * 7) - 24px);
    max-width: calc((100% / 12 * 7) - 24px);
  }
  
  .colx-8 {
    flex: 0 0 calc((100% / 12 * 8) - 8px);
    max-width: calc((100% / 12 * 8) - 8px);
  }
  
  .colx-9 {
    flex: 0 0 calc((100% / 12 * 9) - 24px);
    max-width: calc((100% / 12 * 9) - 24px);
  }
  
  .colx-10 {
    flex: 0 0 calc((100% / 12 * 10) - 24px);
    max-width: calc((100% / 12 * 10) - 24px);
  }
  
  .colx-11 {
    flex: 0 0 calc((100% / 12 * 11) - 24px);
    max-width: calc((100% / 12 * 11) - 24px);
  }
  
  .colx-12 {
    flex: 0 0 calc((100% / 12 * 12));
    max-width: calc((100% / 12 * 12));
  }
  </style>
  